export function reduceToMap<T extends { id: string }>(
  acc: Record<string, T>,
  item: T
) {
  return { ...acc, [item.id]: item };
}
